import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("pf_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("pf_cart", JSON.stringify(items)); }, [items]);

  const add = (item) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.lookup_key === item.lookup_key);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + item.quantity };
        return copy;
      }
      return [...prev, item];
    });
    setOpen(true);
  };
  const remove = (lk) => setItems((p) => p.filter((i) => i.lookup_key !== lk));
  const setQty = (lk, q) => setItems((p) => p.map((i) => (i.lookup_key === lk ? { ...i, quantity: Math.max(1, q) } : i)));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, count, total, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}
